class Polar {
    constructor(r, a) {
        this.r = r;
        this.angle = a;
    }
}
export { Polar };
